import type { ReactNode } from "react";
import type { OpenFile } from "./types";

export function MetadataEditorPanelHeader({
  isLoadingMetadataFile,
  activeFile,
  activeBadge,
  extraActions,
  onRunTest,
  activeFileId,
  // `editorContent` is intentionally not destructured: the `@isTest` gate below
  // is commented out, so nothing reads it and `noUnusedLocals` rejects the
  // binding. It stays in the props type so call sites are unchanged — restore the
  // destructure along with the gate.
  isBusy,
  onClose,
}: {
  isLoadingMetadataFile: boolean;
  activeFile: OpenFile | null;
  activeBadge: string | undefined;
  extraActions?: ReactNode;
  onRunTest?: (className: string) => void;
  activeFileId: string | null;
  editorContent: string;
  isBusy?: boolean;
  onClose: () => void;
}) {
  return (
    <div className="flex items-center justify-between px-4 py-2 border-b bg-muted/50 flex-shrink-0">
      <div className="flex items-center gap-2">
        {isLoadingMetadataFile && (
          <div className="h-4 w-4 animate-spin rounded-full border-2 border-primary border-t-transparent" />
        )}
        {activeFile && (
          <span className="text-sm font-medium truncate flex items-center gap-1.5">
            {activeBadge && (
              <span
                className={`text-[10px] font-bold px-1 rounded ${
                  activeBadge === "R"
                    ? "bg-green-500/20 text-green-400"
                    : activeBadge === "C"
                      ? "bg-blue-500/20 text-blue-400"
                      : "bg-yellow-500/20 text-yellow-400"
                }`}
              >
                {activeBadge}
              </span>
            )}
            {activeFile.name}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2">
        {extraActions}
        {onRunTest &&
          activeFileId &&
         // /@isTest/i.test(editorContent) &&
          activeFile && (
            <button
              type="button"
              onClick={() => {
                const className = activeFile.name.replace(/\.(cls|trigger)$/, "");
                onRunTest(className);
              }}
              disabled={isBusy}
              className="flex items-center gap-1 px-2.5 py-1 text-xs font-medium bg-green-500/10 text-green-400 hover:bg-green-500/20 border border-green-500/20 rounded transition-colors disabled:opacity-40 disabled:cursor-not-allowed"
            >
              ▶ Run Test
            </button>
          )}
        <button
          type="button"
          onClick={onClose}
          className="text-xs text-muted-foreground hover:text-foreground px-2 py-1.5 rounded hover:bg-muted/70 border border-transparent hover:border-border/30"
        >
          Close
        </button>
      </div>
    </div>
  );
}
